import { Component, OnInit } from '@angular/core';
declare var $: any;
import { Router, ActivatedRoute, Params } from '@angular/router';
import { Location } from '@angular/common';
import { ApiService } from '../../../_services/api.service';
import { first } from 'rxjs/operators';
import { NgxUiLoaderService, Loader, SPINNER, POSITION, PB_DIRECTION } from 'ngx-ui-loader';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Chart } from 'chart.js';
import 'chartjs-plugin-labels';

@Component({
  selector: 'app-cnss',
  templateUrl: './cnss.component.html',
  styleUrls: ['./cnss.component.scss']
})
export class CnssComponent implements OnInit {

  cnssList = false;
  page: any;
  response: any;
  cnssReportList: any;
  canvas: any;
  ctx: any;
  entity_type:any;
  employeeId:any;
  cnamgsList:any;
  reportListcnamgs:any;
  cnssReportListresponse:any;

  constructor(private router: Router,
    private route: ActivatedRoute,
    private location: Location,
    private snackBar: MatSnackBar,
    private ngxUiLoaderService: NgxUiLoaderService,
    private api: ApiService, ) {
    if (this.router.getCurrentNavigation().extras.state) {
      this.page = this.router.getCurrentNavigation().extras.state.data;
      console.log("2222222222222222222222222222", this.page)
    }
  }

  ngOnInit() {
    this.route.params.subscribe(
      (params: Params) => {
        console.log(params['id']);
        if (params['id']) {
          this.page = params['id'];
          console.log("33333333333333333", this.page)
        }
      });

      this.route.queryParams.subscribe(params => {
        this.employeeId = params['uuid'];
        this.entity_type = params['entity_type'];
        console.log(this.employeeId, "this.employeeId");
        console.log(this.entity_type, "this.entity_type");
      });

      if(this.entity_type && this.employeeId){
        this.getEmployeeListcnamgs();
      }else{
        this.getReports();
      }
  }
  getChartData() {
    if (this.cnssReportList ) {
       const worker = this.cnssReportList.worker;
       const employer = this.cnssReportList.employer
      console.log("52",employer,worker)
      this.canvas = document.getElementById('balancesheet1');
      console.log(this.canvas)
      this.ctx = this.canvas.getContext('2d');
      console.log(this.ctx)
      let profitLossChart = new Chart(this.ctx, {
        type: 'pie',
        data: {
          //labels: [this.incometxt + ' ' + totalincome + ' FCFA', this.expensetxt + ' ' + totalexpense + ' FCFA'],
          datasets: [{
            data: [worker, employer],
            backgroundColor: [
              "#5d5d5d",
              "#6A8FC2"
            ],
            borderWidth: 1
          }]
        },
        options: {
          responsive: false,
          maintainAspectRatio: false,
          plugins: {
            labels: {
              render: function(args: any) {
                // args will be something like:
                // { label: 'Label', value: 123, percentage: 50, index: 0, dataset: {...} }
                //return args.value + ' ' + "FCFA";
                //return args.label.split(":")[1];
                return;

                // return object if it is image
                // return { src: 'image.png', width: 16, height: 16 };
              },
              fontColor: '#000',
              overlap: true,
              shadowOffsetY: 5
            }
          },
          tooltips: {
            callbacks: {
              label: function(tooltipItem: any, data: any) {
                console.log(tooltipItem)
                console.log(data)
                var label = data.datasets[0].data[tooltipItem.index] || '';
                if (label) {
                  label += '';
                }
                return label;
              }
            }
          }
        }
      });
    }

  }

 


  goBack() {
    this.location.back();
  }
  showCnssList() {
    this.cnssList = true;
    $('#reportModal').modal('hide');
  }
  moreDetails(id: any) {
    return;
  }


  getReports() {
    this.ngxUiLoaderService.start();
    this.api.getReportlist().pipe(first())
      .subscribe(res => {
          this.ngxUiLoaderService.stop();
          this.response = res.results;
          console.log(res)
          if (res.status == 200) {
            this.cnssReportList = this.response
            console.log("50", this.cnssReportList)
            setTimeout(() => {
              this.getChartData();
            },500)

          } else {
            this.snackBar.open(res.message, "OK", {
              duration: 5000,
            });
          }
        },
        error => {
          console.log("error")
          this.ngxUiLoaderService.stop();
        });
  }

  getEmployeeListcnamgs(){
      var data = {
        entity_type : this.entity_type,
        uuid : this.employeeId
      }

    if(this.entity_type && this.employeeId){
      console.log(data, "details");
    this.ngxUiLoaderService.start();
    this.api.employeeReportList(data).pipe(first()).subscribe(res =>{
    this.ngxUiLoaderService.stop();
    this.cnssReportListresponse = res;
    console.log("this.employeeReportListresponse", this.cnssReportListresponse);
    if (this.cnssReportListresponse.status == 200) {
      this.cnssReportList = this.cnssReportListresponse.results;
      setTimeout(() => {
        this.getChartData();
      },500)
    }
    })
    }

  }

}
